import { Stack } from 'expo-router';
import React from 'react';

export default function PhoneEngagementLayout() {
  return <Stack />;
}
